module.exports = "/_next/static/images/OgImage-f358dfc844109333f87066cb63ccfdd5.png";